import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initSentry, Sentry } from "./lib/sentry";

initSentry();

const FallbackUI = () => (
  <div className="min-h-screen flex items-center justify-center bg-background p-6">
    <div className="max-w-md text-center space-y-3">
      <h1 className="text-xl font-semibold text-foreground">Algo salió mal</h1>
      <p className="text-sm text-muted-foreground">
        Hemos registrado el error y nuestro equipo lo revisará. Por favor recarga la página.
      </p>
      <button
        onClick={() => window.location.reload()}
        className="px-4 py-2 rounded-md bg-primary text-primary-foreground text-sm"
      >
        Recargar
      </button>
    </div>
  </div>
);

createRoot(document.getElementById("root")!).render(
  <Sentry.ErrorBoundary fallback={<FallbackUI />}>
    <App />
  </Sentry.ErrorBoundary>,
);
